import React, { Component } from 'react'
import Chip from '@material-ui/core/Chip';
import {AiOutlineFire} from "react-icons/ai";
import {Link} from 'react-router-dom';
import Cover from './../../images/projects/violaInteractive/all-landingPage.png'

export default class ProjectCard extends Component {
        constructor(props){
            super(props);
            this.state = {
                projectImage:[]
            }
        }
        getImgs = async () =>{
            try {
                let response = await this.props.images[0].file.url;
               this.setState({projectImage:response})
                } catch (error) {}
        }
        componentDidMount(){
            this.getImgs();
        }
    render(){
        const subStrDesc = () => {
            let str = this.props.description;
            let res = str.slice(0, 95);
            return res;
        }
        return (
            <Link to={`/projects/${this.props.slug}`}>
                <div className='card-wrap '>
                    <div className="card">
                        {
                        this.props.featured === true ?  <Chip
                        className='exclusive'
                        color="secondary"
                        size="small"
                        icon={< AiOutlineFire />}
                        label={`Featured`}></Chip> :  false
                        
                        }
                      

                        <div className="overlay"></div>
                        <div className="card-bg">
                            <img src={`${this.state.projectImage}` || Cover} alt=""/>
                        </div>
                        {/* background */}
                        <div className="card-info inner-element">
                            <h1 >{this.props.name}</h1>
                            <p>{subStrDesc()}</p>
                        </div>
                    </div>
                </div>
            </Link>
    
        )
    }

}